function page(data, p) {
    let page = parseInt(p.currentPage);
    let size = parseInt(p.pageSize);
    if (page === 0) {
        page++;
    }
    let start = (page - 1) * size;
    let end = start + size;
    if (end > data.length) {
        end = data.length;
    }
    // console.log('分页 page: %o, start: %d, end: %d', p, start, end);
    return data.slice(start, end);
}

function save(data, list) {
    data.id = parseInt(data.id);
    data.company.id = parseInt(data.company.id);
    data.target.id = parseInt(data.target.id);
    let index = findIndexById(list, data.id);
    console.log('index: %d, row: %o', index, list[index]);
    if (index === -1) {
        data.id = list[list.length - 1].id + 1;
        list.push(data);
        index = list.length - 1
    } else {
        list[index] = data;
    }
    return index;
}

function findById(list, id) {
    return list.find(function (value, index, arr) {
        return value.id === id;
    });
}

function findIndexById(list, id) {
    return list.findIndex(function (value, index, arr) {
        // console.log('value: %o, index: %d, id: %d', value, index, id);
        return value.id === id;
    });
}

export {page, save, findById, findIndexById}
